import React, { useState, useEffect, useRef } from 'react';
import css from './ProfileShareQR.module.css';

const QRModal = ({ url, onClose }) => {
  const canvasRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    import('qrcode').then(QRCode => {
      if (cancelled || !canvasRef.current) return;
      QRCode.toCanvas(canvasRef.current, url, { width: 240, margin: 2 }, err => {
        if (err && !cancelled) setError(true);
      });
    }).catch(() => {
      if (!cancelled) setError(true);
    });
    return () => { cancelled = true; };
  }, [url]);

  const handleDownload = () => {
    if (!canvasRef.current) return;
    const link = document.createElement('a');
    link.download = 'profile-qr.png';
    link.href = canvasRef.current.toDataURL('image/png');
    link.click();
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {}
  };

  return (
    <div className={css.overlay} onClick={onClose}>
      <div className={css.modal} onClick={e => e.stopPropagation()}>
        <button type="button" className={css.closeBtn} onClick={onClose} aria-label="Close">✕</button>
        <h3 className={css.title}>Share Profile</h3>
        <p className={css.subtitle}>Scan or share this link</p>
        <div className={css.qrWrap}>
          {error ? (
            <p className={css.errorMsg}>QR generation failed — copy the link below.</p>
          ) : (
            <canvas ref={canvasRef} className={css.canvas} />
          )}
        </div>
        <div className={css.urlRow}>
          <span className={css.urlText}>{url}</span>
          <button type="button" className={css.copyBtn} onClick={handleCopy}>Copy</button>
        </div>
        <button type="button" className={css.downloadBtn} onClick={handleDownload}>Download QR</button>
      </div>
    </div>
  );
};

const ProfileShareQR = ({ profileUrl }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className={css.shareBtn}
        onClick={() => setOpen(true)}
        title="Share profile via QR code"
        aria-label="Share profile via QR code"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="18" height="18" aria-hidden="true">
          <rect x="3" y="3" width="7" height="7" rx="1" />
          <rect x="14" y="3" width="7" height="7" rx="1" />
          <rect x="3" y="14" width="7" height="7" rx="1" />
          <rect x="5" y="5" width="3" height="3" fill="currentColor" stroke="none" />
          <rect x="16" y="5" width="3" height="3" fill="currentColor" stroke="none" />
          <rect x="5" y="16" width="3" height="3" fill="currentColor" stroke="none" />
          <path d="M14 14h3v3h-3z" fill="currentColor" stroke="none" />
          <path d="M17 14h4M17 17v4M14 17h3" />
        </svg>
        <span>Share</span>
      </button>
      {open && <QRModal url={profileUrl} onClose={() => setOpen(false)} />}
    </>
  );
};

export default ProfileShareQR;
